/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// CHECKOUT SCRIPT
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    if (e.target.matches('.Cart__Checkout')) {
      console.log('Checkout button clicked');
    }
  });
});


// FREE GIFT
document.addEventListener('quantity:updated', function(event) {
    var sidebar_cart = document.querySelector("#sidebar-cart");
    var main_cart_page = document.querySelector("#main-cart-page");
    var free_gift_enabled = false;

   if(!sidebar_cart){
     sidebar_cart = main_cart_page;
   }
  

    if (sidebar_cart) {
        var sidebar_cart_options = JSON.parse(sidebar_cart.getAttribute('data-section-settings'));
        var free_gift_enabled = sidebar_cart_options["FreeGift"];
    }

    if (free_gift_enabled) {

        var free_gift_threshold = sidebar_cart_options["GiftThreshold"];
        var free_gift_variant = sidebar_cart_options["FreeGiftProduct"];

        if (free_gift_threshold != "" && free_gift_variant != "") {

            fetch("".concat(window.routes.cartUrl).concat('.js', "?timestamp=").concat(Date.now()), {
                    credentials: 'same-origin',
                    method: 'GET'
                }).then(response => response.json())
                .then(cart => {
                  if(typeof window.BOLD !== 'undefined'
                      && typeof window.BOLD.common !== 'undefined'
                      && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                    cart = window.BOLD.common.cartDoctor.fix(cart);
                  }
                    if (cart.item_count > 0) {
                        var found_variant_in_cart = false;
                        var found_variant_index = 1;
                        var cart_total_price = cart.total_price;

                        for (let index = 0; index < cart.items.length; index++) {
                            if (cart.items[index].variant_id == free_gift_variant) {
                                cart_total_price = cart_total_price - cart.items[index].price;
                                found_variant_in_cart = true;
                                found_variant_index = index + 1;
                                break;
                            }
                        }

                        if (cart_total_price >= free_gift_threshold && found_variant_in_cart == false) {

                            var formData = {
                                'items': [{
                                    'id': free_gift_variant,
                                    'quantity': 1
                                }]
                            };
                            fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header      
                                    },
                                    body: JSON.stringify(formData)
                                })
                                .then(response => {
                                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                        bubbles: true
                                    }));
                                })
                                .catch((error) => {
                                    console.error('Error:', error);
                                });

                        } else if (cart_total_price < free_gift_threshold && found_variant_in_cart == true) {
                            fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                                    body: JSON.stringify({
                                        'line': found_variant_index,
                                        'quantity': 0
                                    }),
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

                                    }
                                }).then(response => {
                                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                        bubbles: true
                                    }));
                                })
                                .catch((error) => {
                                    console.error('Error:', error);
                                });

                        }
                    }
                    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
                      BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
                    }
                });
        }
    }
})